import { Traceable } from './assistant'
import { TimeType } from './generic'

export type ChatSessionDTO = {
  beneficiaryId: string
  closedAt?: TimeType
  id: string
  startedAt: TimeType
}

export enum ChatMessageSender {
  Beneficiary = 'beneficiary',
  Bot = 'bot',
  CaseWorker = 'caseworker',
}

export type ChatMessageDTO = {
  content: string
  sentAt: TimeType
  id: string
  sender: ChatMessageSender
} & Traceable

export type BaseMessageType = {
  createdAtTime: TimeType
  id: string
  content: string
  isSender: boolean
}

export type SenderType = 'coach' | 'youth'

export type MessageType = BaseMessageType & {
  type: 'message'
  sender: SenderType
}
